import {useSelector} from 'react-redux';
import {RootState} from '../../../store/rootReducer';
import useCan, {AI_RESTYLE} from '../../../permissions/ability';
import {useGetOrganizationEntitlementsQuery} from '../../../store/endpoints/OrganizationsEndpoints';

/**
 * Whether this user gets the Adaptive Intelligence launcher at all.
 *
 * The launcher appears when the user holds at least one assistant capability. Today that is the
 * aiRestyle permission plus the organization's aiRestyleEnabled entitlement; when a second
 * capability lands, OR it in here rather than at each call site. The client check is cosmetic, as
 * always: every route re-checks both the policy and the entitlement server-side.
 */
export const useAssistantAvailable = (): boolean => {
    const selectedOrganization = useSelector((state: RootState) => state.settings.selectedOrganization);
    const canAiRestyle = useCan(AI_RESTYLE);
    const entitlements = useGetOrganizationEntitlementsQuery(selectedOrganization ?? '', {
        skip: !selectedOrganization || selectedOrganization === '',
    });

    return canAiRestyle && entitlements.data?.aiRestyleEnabled === true;
};

export default useAssistantAvailable;
